import { detectDeviceEnvironmentConstants, dispatcher, IEvent, ingenuity, IObject } from "@quest/base-core";
import { FreeGameView } from "./FreeGameView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotConstantsBehavior";
import { SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist/Game/BehaviorConstants/SlotEventDispatchersBehavior";

export class FreeGameProgressBar {
    protected view: FreeGameView;
    private cascadeCount: number;

    /**
     * Constrcutor method to initialize events and UI elements.
     * @param baseGameView 
     */
    constructor(baseGameView: FreeGameView) {
        this.view = baseGameView;
        this.subscribeEvents();
    }
    /**
     * Class method to subscribe events.
     */
    private subscribeEvents(): void {
        this.unSubscribeEvents()
        dispatcher.on(eventDispatchers.UPDATE_PROGRESS_BAR_IN_FREEGAME, this.startProgressOnCascade, this)
        dispatcher.on(eventDispatchers.RESET_PROGRESS_BAR_IN_FREEGAME, this.resetProgressBar, this)
        dispatcher.on(eventDispatchers.ALLIGN_PROGRESS_BALLS_FREEGAME, this.allignBallsAngle, this)
        
    }
    private unSubscribeEvents(): void {
        dispatcher.off(eventDispatchers.UPDATE_PROGRESS_BAR_IN_FREEGAME, this.startProgressOnCascade, this)
        dispatcher.off(eventDispatchers.RESET_PROGRESS_BAR_IN_FREEGAME, this.resetProgressBar, this)
        dispatcher.off(eventDispatchers.ALLIGN_PROGRESS_BALLS_FREEGAME, this.allignBallsAngle, this)
    }
    /**
     * check and send call to different progress points
     */
    private startProgressOnCascade(evt: IEvent): void {
        this.cascadeCount = (ingenuity.parserModel as GameParserModel).getCascadeNumber();
        this.deactivatePreviousProgress(this.cascadeCount);
        if (this.cascadeCount < 8) {
            if (this.cascadeCount <= 3) {
                this.playProgressAnim(this.cascadeCount, "small")
            } else {
                this.playProgressAnim(this.cascadeCount, "big");
            }
            if (this.cascadeCount === 4) {
                this.playFreeSpinTriggeringAnim();
            }
            this.playSound();
        }
    }

    private playSound(): void {
        let soundKey: string = SoundConstantGame.FREE_SPIN_PROGRESS_1;
        switch (this.cascadeCount) {
            case 1:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_1_fs;
                break;
            case 2:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_2_fs;
                break;
            case 3:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_3_fs;
                break;
            case 4:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_4_fs;
                break;
            case 5:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_5_fs;
                break;
            case 6:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_6_fs;
                break;
            case 7:
                soundKey = SoundConstantGame.FREE_SPIN_PROGRESS_7_fs;
                break;
        }
        const soundObj: IObject = { id: soundKey, vol: 1, loop: false, key: SlotConstantsBehavior.SOUND_LIST_POSTLOAD };
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, soundObj);
    }

    /**
     * show previous filled progress aniamtion
     */
    private deactivatePreviousProgress(count: number): void {
        for (let previousIndex = 1; previousIndex < count; previousIndex++) {
            previousIndex <= 3 ? this.playInActiveAnim(previousIndex, "small") : this.playInActiveAnim(previousIndex, "big");
        }
    }
    /**
     * play all progressbar animations
     */
    private playProgressAnim(count: number, ballSize: string): void {
        const spineBackRay = this.view.getSpineById("progressBackRay_" + count);
        const spineFillBall = this.view.getSpineById("progressFillBall_" + count);
        this.allignAngle(spineFillBall)
        spineBackRay.visible = true;
        spineFillBall.visible = true;
        spineBackRay.setPause(false);
        spineFillBall.setPause(false);
        spineFillBall.playAnim(`${ballSize}_intro_effect_freegame`);
        spineFillBall.onComplete.addOnce(() => {
            spineBackRay.playAnim(`${ballSize}_loop_effect_freegame`, true);
            spineFillBall.playAnim(`active_${ballSize}_idle`, true);
        }, this);
        this.view.getMeterById(`progressActiveMtr_${count}`) && (this.view.getMeterById(`progressActiveMtr_${count}`).visible = true);
    }
    /**
     * to allig spine  angle
     */
    private allignAngle(spine: any): void {
        spine.scale.set(spine.json.scaleX || 1, spine.json.scaleY || 1)
        !ingenuity.deviceEnv.isDesktop && this.allignBallsAngle();
    }
    /**
     * to allign items on rotation
     */
    private allignBallsAngle(): void {
        this.view.json.rotateBalls.forEach((name: string) => {
            const spine: any = (this.view.getSpineById(name) as any)
            const backRay: any = (this.view.getSpineById("progressPanelBackEffect") as any);
            if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
                spine.scale.set(1, spine.json.scaleX)
                backRay.angle = 90
            } else {
                spine.scale.set(spine.json.scaleX, 1)
                backRay.angle = 0
            }
        })
    }
    /**
     * to play previous filled progress anim
     */
    private playInActiveAnim(count: number, ballSize: string): void {
        const spineBackRay = this.view.getSpineById("progressBackRay_" + count);
        const spineFillBall = this.view.getSpineById("progressFillBall_" + count);
        spineBackRay.setPause(true);
        spineBackRay.visible = false;
        spineFillBall.playAnim(`inactive_${ballSize}_idle`, true);
        this.view.getImageById(`progressActiveMtr_${count}`) && (this.view.getImageById(`progressActiveMtr_${count}`).visible = true);
    }
    /**
     * to play triggereing time anims
     */
    private playFreeSpinTriggeringAnim(): void {
        const panelBG = this.view.getSpineById("progressPanelBackEffect")
        const textEffect = this.view.getSpineById("freeSpinTextBgEffect")
        panelBG.setPause(false);
        textEffect.setPause(false);
        panelBG.visible = true;
        textEffect.visible = true;
        panelBG.playAnim("bg_glow_effect", true);
        textEffect.playAnim("freespins_intro_effect_freegame", false);
        textEffect.onComplete.addOnce(() => {
            textEffect.playAnim("freespins_intro_effect_freegame_loop", true);
        }, this);
        this.view.getImageById("freespinTxtActive").visible = true;
    }
    /**
     * to reset progress bar
     */
    private resetProgressBar(): void {
        this.view.json.animationArray.forEach((name: string) => {
            const spineAnim = this.view.getSpineById(name);
            spineAnim.setPause(true);
            spineAnim.visible = false;
        })
        this.view.json.visibleAssetsArray.forEach((name: string) => {
            this.view.getMeterById(name).visible = false;
        })
        this.view.getImageById("freespinTxtActive").visible = false;
    }
}